import { css } from 'lit';

export const levelContentStyles = css`
  :host {
    display: flex;
    flex-direction: column;
    container-type: inline-size;
    position: relative;
  }

  d-page-header {
    flex: none;
  }

  .content {
    flex: 1;
    max-width: 784px;
    box-sizing: border-box;
    margin-top: -1px;
    padding: 0 20px;
    transition: padding 0.5s;
  }

  :host(.width600) .content {
    padding: 0 30px;
  }

  :host([covered]) .content {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    direction: rtl;
  }

  .content > * {
    direction: ltr;
  }

  .content::after {
    content: '';
    display: block;
    height: 100px;
  }

  :host([wide-page]) .content {
    max-width: unset;
  }
  .page-link {
    display: block;
    border-top: 1px solid var(--borderColorOnGray);
    padding: 12px 0 12px var(--listPaddingLeft);
    background-image: url(/images/related-color.svg);
    background-size: 30px 30px;
    background-position: -2px 8px;
    background-repeat: no-repeat;
    font-weight: 500;
    color: var(--linkColorGray);
    font-size: 17px;
    text-decoration: none;
  }
  @media (hover: hover) {
    .page-link:hover {
      color: black;
    }
  }
`;
